import { createVanIconComponent } from "./van"

const Failure = createVanIconComponent("failure")
export default Failure
